import { Container } from "@mui/material";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import ErrorCard from "@/components/ErrorCard";
import FullPageSpinner from "@/components/FullPageSpinner";
import type { Auth0LoadPromise } from "@/hooks/useAuth0LoadPromise.ts";
import type { QueryOptionsFactory } from "@/queries";

export type RootRouterContext = {
    queryClient: QueryClient;
    qof: QueryOptionsFactory;
    auth0LoadPromise: Auth0LoadPromise;
};

export const Route = createRootRouteWithContext<RootRouterContext>()({
    component: Outlet,
    pendingComponent: FullPageSpinner,
    errorComponent: ({ error }) => (
        <Container maxWidth="md" sx={{ my: 2 }}>
            <ErrorCard error={error} />
        </Container>
    ),
});
